import HiveAlexS1 from "./images/cards/seed_events/boardgame-co-hive/Hive-Alex-S1.png";
import HiveAlexS2 from "./images/cards/seed_events/boardgame-co-hive/Hive-Alex-S2.png";
import HiveAlexS3 from "./images/cards/seed_events/boardgame-co-hive/Hive-Alex-S3.png";
import HiveJennaS1 from "./images/cards/seed_events/boardgame-garden-hive/Hive-Jenna-S1.png";
import HiveJennaS2 from "./images/cards/seed_events/boardgame-garden-hive/Hive-Jenna-S2.png";
import HiveJennaS3 from "./images/cards/seed_events/boardgame-garden-hive/Hive-Jenna-S3.png";
import ZenithGardenCo_G1_S1_Prepper from "./images/cards/seed_events/zenith-garden-co/ZenithGardenCo_G1_S1_Prepper.png";
import ZenithGardenCo_G1_S2_Paperwork from "./images/cards/seed_events/zenith-garden-co/ZenithGardenCo_G1_S2_Paperwork.png";
import ZenithGardenCo_G1_S3_Stockers from "./images/cards/seed_events/zenith-garden-co/ZenithGardenCo_G1_S3_Stockers.png";
import ZenithGardenCo_G2_S1_Trainee from "./images/cards/seed_events/zenith-garden-co/ZenithGardenCo_G2_S1_Trainee.png";
import ZenithGardenCo_G2_S2_Prospector from "./images/cards/seed_events/zenith-garden-co/ZenithGardenCo_G2_S2_Prospector.png";
import ZenithGardenCo_G2_S3_Crafter from "./images/cards/seed_events/zenith-garden-co/ZenithGardenCo_G2_S3_Crafter.png";
import ZenithGardenCo_G3_S1_Smuggler from "./images/cards/seed_events/zenith-garden-co/ZenithGardenCo_G3_S1_Smuggler.png";
import ZenithGardenCo_G3_S2_MasterTrader from "./images/cards/seed_events/zenith-garden-co/ZenithGardenCo_G3_S2_MasterTrader.png";
import ZenithGardenCo_G3_S3_SpecialOrder from "./images/cards/seed_events/zenith-garden-co/ZenithGardenCo_G3_S3_SpecialOrder.png";
import NewModulesIncoming_S1_NewEquipment from "./images/cards/action_cards/seed_events/newmodulesincoming/NewModulesIncoming_S1_NewEquipment.png";
import NewModulesIncoming_S2_Adaptation from "./images/cards/action_cards/seed_events/newmodulesincoming/NewModulesIncoming_S2_Adaptation.png";
import NewModulesIncoming_S3_Investments from "./images/cards/action_cards/seed_events/newmodulesincoming/NewModulesIncoming_S3_Investments.png";

export interface SeedEventCardDefinition {
    name: string;
    imageUrl: string;
}

export const ZENITH_GARDEN_CO_SEED = "zenith-garden-co";

// Kept separate from the random objective and action-card pools.
const zenithGardenCoObjectives: Record<1 | 2 | 3, SeedEventDefinition["seasonEndCards"]> = {
    1: {
        1: { name: "ZenithGardenCo_G1_S1_Prepper", imageUrl: ZenithGardenCo_G1_S1_Prepper },
        2: { name: "ZenithGardenCo_G1_S2_Paperwork", imageUrl: ZenithGardenCo_G1_S2_Paperwork },
        3: { name: "ZenithGardenCo_G1_S3_Stockers", imageUrl: ZenithGardenCo_G1_S3_Stockers }
    },
    2: {
        1: { name: "ZenithGardenCo_G2_S1_Trainee", imageUrl: ZenithGardenCo_G2_S1_Trainee },
        2: { name: "ZenithGardenCo_G2_S2_Prospector", imageUrl: ZenithGardenCo_G2_S2_Prospector },
        3: { name: "ZenithGardenCo_G2_S3_Crafter", imageUrl: ZenithGardenCo_G2_S3_Crafter }
    },
    3: {
        1: { name: "ZenithGardenCo_G3_S1_Smuggler", imageUrl: ZenithGardenCo_G3_S1_Smuggler },
        2: { name: "ZenithGardenCo_G3_S2_MasterTrader", imageUrl: ZenithGardenCo_G3_S2_MasterTrader },
        3: { name: "ZenithGardenCo_G3_S3_SpecialOrder", imageUrl: ZenithGardenCo_G3_S3_SpecialOrder }
    }
};

// These objectives belong only to their exact Hive seed, never to shared pools.
const hiveInfluencerObjectives: Record<string, SeedEventDefinition["seasonEndCards"]> = {
    "boardgame-co-hive": {
        1: { name: "Hive-Alex-S1", imageUrl: HiveAlexS1 },
        2: { name: "Hive-Alex-S2", imageUrl: HiveAlexS2 },
        3: { name: "Hive-Alex-S3", imageUrl: HiveAlexS3 }
    },
    "boardgame-garden-hive": {
        1: { name: "Hive-Jenna-S1", imageUrl: HiveJennaS1 },
        2: { name: "Hive-Jenna-S2", imageUrl: HiveJennaS2 },
        3: { name: "Hive-Jenna-S3", imageUrl: HiveJennaS3 }
    },
};

export function isHiveInfluencerSeed(seed: string | undefined | null): boolean {
    return Object.prototype.hasOwnProperty.call(hiveInfluencerObjectives, normalizeSeed(seed));
}

export function isCellarCampaignSeed(seed: string | undefined | null): boolean {
    return normalizeSeed(seed) === ZENITH_GARDEN_CO_SEED;
}

export function getSeedEventCardDefinition(name: string): SeedEventCardDefinition | undefined {
    return [...Object.values(zenithGardenCoObjectives), ...Object.values(hiveInfluencerObjectives)].reduce<SeedEventCardDefinition[]>((cards, seasons) => cards.concat(Object.values(seasons)), [])
        .find(card => card.name === name);
}

export const NEW_MODULES_INCOMING_SEED = "newmodulesincoming";

export interface SeedEventDefinition {
    seed: string;
    seasonEndCards: Record<1 | 2 | 3, SeedEventCardDefinition>;
}

export function normalizeSeed(seed: string | undefined | null): string {
    return seed?.trim().toLocaleLowerCase() ?? "";
}

export function getSeedEventDefinition(seed: string | undefined | null, campaignGameNumber: 1 | 2 | 3 = 1): SeedEventDefinition | null {
    const normalizedSeed = normalizeSeed(seed);

    if (isHiveInfluencerSeed(normalizedSeed)) {
        return { seed: normalizedSeed, seasonEndCards: hiveInfluencerObjectives[normalizedSeed] };
    }

    if (isCellarCampaignSeed(normalizedSeed)) {
        return { seed: normalizedSeed, seasonEndCards: zenithGardenCoObjectives[campaignGameNumber] };
    }

    if (normalizedSeed !== NEW_MODULES_INCOMING_SEED) {
        return null;
    }

    return {
        seed: normalizedSeed,
        seasonEndCards: {
            1: {
                name: "NewModulesIncoming_S1_NewEquipment",
                imageUrl: NewModulesIncoming_S1_NewEquipment
            },
            2: {
                name: "NewModulesIncoming_S2_Adaptation",
                imageUrl: NewModulesIncoming_S2_Adaptation
            },
            3: {
                name: "NewModulesIncoming_S3_Investments",
                imageUrl: NewModulesIncoming_S3_Investments
            }
        }
    };
}
